export default __webpack_public_path__ + "static/AntIcon115-694333127af4150d74eb80878668c888.png";